module.exports = __webpack_public_path__ + "static/media/brazil.845a5357.svg";